import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
})
/**
 * Faq page
 */
export class FaqPage implements OnInit {
  RouterKeys = RoutesKeys;
  termsAndConditionsLink?: string;
  privacyPolicyLink?: string;
  /**
   * Constructor
   */
  constructor(
    private registerService: RegisterService,
    private viewportScroller: ViewportScroller
  ) {}

  /**
   * Init
   */
  ngOnInit() {
    this.registerService
      .getTermsOfUseAndPrivacyConditionsURLs()
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.termsAndConditionsLink = res.termsOfUseURL;
          this.privacyPolicyLink = res.privacyConditionsURL;
        },
      });
  }

  /**
   *  Scrolls to anchor
   * @param {string} elementId elementId of the screen
   */
  onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }
}
